import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { Skin } from './skin.enum';

/** This service has the business logic related to the Skin manager. */
@Injectable({
    providedIn: 'root',
})
export class SkinService {
    skin: Skin = Skin.default;
    changeSkin$: Subject<Skin> = new Subject();

    constructor(@Inject(DOCUMENT) private document: Document) {}

    /**
     * Sets the skin and change the css theme
     */
    setSkin(skin: Skin): void {
        this.skin = skin;
        this.document.getElementById('theme')?.setAttribute('href', `assets/themes/${this.skin}.css`);
        this.changeSkin$.next(this.skin);
    }

    /**
     * @returns the current skin
     */
    getSkin(): Skin {
        return this.skin;
    }

    /**
     * Gets the button toolbar size
     */
    getButtonToolbarSize(): number {
        const buttonToolbarSize = getComputedStyle(this.document.documentElement).getPropertyValue('--buttonToolbarSize');
        return +buttonToolbarSize;
    }

    getButtonToolbarMargin(): number {
        const buttonToolbarMargin = getComputedStyle(this.document.documentElement).getPropertyValue('--buttonToolbarMargin');
        return buttonToolbarMargin === undefined ? 1 : +buttonToolbarMargin;
    }
}
